import React from "react";

export default function IllustrativeNote({ children, className = "" }) {
  return <p className={["text-[11px] leading-relaxed text-muted", className].join(" ")}>{children}</p>;
}
